<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner7.png" alt="" />
    <div class="main">
      <ul class="Breadcrumb" v-if="languageCode == 'zh'">
        <li @click="backPage('/home')">首页</li>
        <li>></li>
        <li>质量与可靠性</li>
      </ul>
      <ul class="Breadcrumb" v-else>
        <li @click="backPage('/home')">Home</li>
        <li>></li>
        <li>Quality & Reliability</li>
      </ul>

      <div class="content">
        <div class="menu">
          <div v-if="languageCode == 'zh'" @click="getNode" class="top">质量与可靠性</div>
          <div v-else @click="getNode" class="top">Quality & Reliability</div>
          <el-tree
            ref="tree"
            show-checkbox
            node-key="id"
            :data="treeData"
            :default-expand-all="true"
            :default-checked-keys="[id]"
            :props="defaultProps"
            @node-click="getNode"
            :check-strictly="true"
          ></el-tree>
        </div>
        <div class="apply">
          <h3 class="tab_title">{{ node.title }}</h3>
          <div class="editor" v-html="node.content"></div>
          <div v-for="(item, index) in files" class="file">
            <div class="fleft">
              <img src="../../assets/icon23.png" alt="" />
            </div>
            <div class="fleft">
              <p>{{ item.name }}</p>
              <a class="download" :href="item.fileUrl" target="_blank">下载</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDictList,
  getNewsDetail,
  getZlglList,
  getNewsZlglList,
} from "../../api/index";
export default {
  data() {
    return {
      id: "",
      content: "",
      treeData: [],
      defaultProps: {
        children: "childrens",
        label: "name",
      },
      node: {},
      files: [],
      languageCode:""
    };
  },
  methods: {
    getNode(node) {
      if ("content" in node) {
        this.node = node;
        this.id = this.node.id;
        this.$refs.tree.setCheckedKeys([this.id]);
        getNewsZlglList({ qualityReliabilityId: node.id }).then((res) => {
          console.log(res);
          this.files = res.rows;
        });
      }
    },
    getLocalizedPath(rawPath) {
    const currentLang = this.$i18nState.locale || "zh";
    // 如果路径已经以 /zh 或 /en 结尾，则直接返回
    if (/\/(zh|en)$/.test(rawPath)) {
      return rawPath;
    }
    // 移除路径末尾多余的斜杠，然后添加语言
    const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
    return `${base}/${currentLang}`;
    },
    backPage(page) {
      if (page == "-1") {
        this.$router.go(-1);
      } else {
        const fullPath = this.getLocalizedPath(page);
        this.$router.replace({path:fullPath});
      }
    },
  },
  mounted() {
    const lang = this.$i18nState.locale;   // ✅ 正确的语言获取方式
    this.languageCode = lang
    getDictList("cms_quality_reliability").then((res) => {
      let data = res.data;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "name", lang == 'zh'?element.dictLabel:element.dictLabelEn);
        getZlglList({ category: element.dictCode,languageCode:lang == 'zh'?'zh-CN':"en-US" }).then((res1) => {
          for (let i = 0; i < res1.rows.length; i++) {
            const element1 = res1.rows[i];
            this.$set(element1, "name", element1.title);
          }
          this.$set(element, "childrens", res1.rows);
        });
      }
      setTimeout(() => {
        this.node = data[0].childrens[0];
        this.id = this.node.id;
        this.$refs.tree.setCheckedKeys([this.id]);
      }, 100);

      this.treeData = res.data;
    });
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;

  .menu {
    width: 250px;
  }

  .apply {
    flex: 1;
    margin-left: 30px;
    overflow: hidden;
  }
}

.top {
  background: url("../../assets/img13.png") #1f3b6d;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
  color: #fff;
}

.active {
  background-color: #476da7;
  color: #d1d1d1;
}

.menu {
  width: 250px;

  ul {
    li {
      width: 250px;
      line-height: 66px;
      border-bottom: 1px solid #cfcfcf;
      background-color: #fff;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
    }

    li:last-child {
      border: none;
    }
  }
}

.download {
  display: block;
  background: url("../../assets/icon15.png") no-repeat #cfcfcf;
  background-size: contain;
  // margin-top: 10px;
  padding-left: 32px;
  width: 102px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 15px;
  border-radius: 8px;
}

.file {
  overflow: hidden;
  margin-top: 20px;

  .fleft {
    // height: 180px;
    img {
      width: 92px;
      border-radius: 5px;
    }

    p {
      font-size: 16px;
      color: #151515;
      margin-bottom: 20px;
      margin-top: 20px;
      display: block;
      overflow: hidden; //超出文本隐藏
      text-overflow: ellipsis; ///超出部分省略号显示
      display: -webkit-box; //弹性盒模型
      -webkit-box-orient: vertical; //上下垂直
      -webkit-line-clamp: 1;
      line-height: 20px;
      height: 20px;
    }

    span {
      color: #151515;
      margin-bottom: 16px;
      display: block;
      cursor: pointer;
      font-size: 14px;
    }
  }

  .fleft:first-child {
    width: 120px;
  }

  .fleft:last-child {
    width: 760px;
  }
}
.editor {
  td,
  table,
  th,
  tr {
    border: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/zlykkx/index.vue